<template>
  <div>
    <label class="text-left block" :for="id">
      <slot></slot>
    </label>
    <Input 
      class="w-full rounded-md !shadow w-full border-gray-300" 
      :id="id"
      type="date" 
      v-model="model" 
      :disabled="disabled" 
      :value="value" 
      :min="min" 
      :max="max" 
      :required="required"
      @blur="$emit('blur', $event); blurEvent()" >
    </Input>
    <InputError 
      :label="errorLabel" 
      :condition="(errorCondition && required && edited)"
    />
  </div>
</template>

<script>
import Input from '../Input.vue'
import InputError from './InputError.vue'

export default {
  props: {
    disabled: Boolean,
    required: Boolean,
    value: String,
    min: String,
    max: String,
    errorLabel: String,
    errorCondition: Boolean,
    id: String,
  },
  components: {
    Input,
    InputError
  },
  data() {
    return {
      edited: false,
    };
  },
  methods: {
    blurEvent(){
      this.edited = true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>